<template>
  <div class="app_form">
    <van-dropdown-menu
      :class="isMobile ? 'topBar isMobile' : 'topBar notMobile'"
      get-container="body"
      :close-on-click-outside="false"
      active-color="#1989fa"
    >
      <van-dropdown-item title="筛选" ref="filter">
        <van-form>
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.currentDate"
            label="日期"
            placeholder="点击选择"
            @click="showPicker = true"
          />
          <van-field
            readonly
            clickable
            clearable
            name="picker"
            :value="param.params.zyzt"
            label="作业完成状态"
            placeholder="点击选择状态"
            @click="showProcPicker = true"
          />
        </van-form>
        <div style="margin: 10px; display: flex; justify-content: center">
          <van-button
            size="small"
            round
            native-type="submit"
            style="padding: 0 20px; margin-right: 20px"
            @click="clearData"
            >重置</van-button
          >
          <van-button
            size="small"
            round
            type="info"
            native-type="submit"
            style="padding: 0 20px"
            @click="onSubmit"
            >筛选</van-button
          >
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
    <!-- 流程弹出框 -->
    <van-popup v-model="showProcPicker" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="选择作业完成状态"
        show-toolbar
        visible-item-count="5"
        :columns="['作业中', '空闲中']"
        @confirm="onConfirm"
        @cancel="showProcPicker = false"
      />
    </van-popup>
    <van-popup v-model="showPicker" position="bottom" get-container="#app">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择日期"
        @confirm="onDeal"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-list :style="isMobile ? 'padding-top: 45px;' : 'padding-top: 90px;'">
      <el-card class="card_form" style="margin: 10px" v-for="item in taskData">
        <div class="app_form_title">
          <span class="formName">{{ item.name | ellipsis }}</span>
          <div class="step">
            <van-steps :active="0" direction="vertical">
              <van-step v-for="sItem in taskColumn">
                {{ sItem.label + ':' }}
                <span class="span">{{ item[sItem.prop] }}</span>
              </van-step>
            </van-steps>
          </div>
        </div>
      </el-card>
    </van-list>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getData"
    >
      <el-card class="card_form" style="margin: 10px" v-for="item in tableData">
        <div class="app_form_title">
          <span class="formName">{{ item.name | ellipsis }}</span>
          <div class="step">
            <van-steps :active="0" direction="vertical">
              <van-step v-for="sItem in tableColumn">
                {{ sItem.label + ':' }}
                <span class="span">{{ item[sItem.prop] }}</span>
              </van-step>
            </van-steps>
          </div>
        </div>
      </el-card>
    </van-list>
  </div>
</template>
<script>
import * as hoistApplyApi from '../../../api/hoistApply'
import { formatDate } from '../../../util/formatUtil'
import {
  Step,
  Steps,
  Empty,
  List,
  Icon,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Button,
  Search,
  Form,
  Field,
  Popup,
  Picker,
  DatetimePicker
} from 'vant'
export default {
  data() {
    return {
      tableColumn: [
        { label: '作业负责人姓名', prop: 'xm' },
        { label: '工号', prop: 'gh' },
        { label: '任务数量', prop: 'task_num' },
        { label: '已完成', prop: 'success' },
        { label: '未完成', prop: 'no_success' },
        { label: '当前状态', prop: 'zyzt' }
      ],
      taskColumn: [
        { label: '任务数量', prop: 'task_num' },
        { label: '已完成', prop: 'success' },
        { label: '未完成', prop: 'no_success' },
        { label: '待主管分配任务', prop: 'dzgfprw' }
      ],
      taskData: [],
      tableData: [],
      param: {
        page: 0,
        size: 10,
        params: {
          currentDate: this.getDate(new Date()),
          wfp: true,
          zyfzr2_order: 'desc'
        }
      },
      isMobile: false,
      loading: false,
      finished: false,
      showProcPicker: false,
      showPicker: false,
      currentDate: new Date()
    }
  },
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Empty.name]: Empty,
    [List.name]: List,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Search.name]: Search,
    [Field.name]: Field,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [DatetimePicker.name]: DatetimePicker
  },
  mounted() {
    //标记从哪个页面跳过来的，mb 表示移动端
    if (
      navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 检测是否手机端
      this.isMobile = true
    }
  },
  filters: {
    //文字数超出时，超出部分使用...
    ellipsis(value) {
      if (!value) return ''
      if (value.length > 12) {
        return value.slice(0, 12) + '...'
      }
      return value
    }
  },
  methods: {
    getData() {
      // 获取吊装申请列表
      this.param.page += 1
      hoistApplyApi
        .queryTotalData(this.param)
        .then((res) => {
          this.loading = false
          if (res.success) {
            this.taskData = res.data.totalData
            if (this.param.page === 1) this.tableData = []
            let data = []
            if (res.data.detailData.data.length) {
              res.data.detailData.data.forEach((item) => {
                this.tableData.push(item)
              })
            } else {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.finished = true
          this.loading = false
        })
    },
    clearData() {
      //清空表单数据
      // this.param.params.zysjd2 = ''
      this.param.params.currentDate = ''
      this.param.params.zyzt = ''
      this.param.page = 0
      this.finished = false
      this.$refs.filter.toggle()
    },
    onSubmit() {
      this.param.page = 0
      this.$refs.filter.toggle()
      if (this.finished) {
        this.finished = false
      } else {
        this.getData()
      }
    },
    onConfirm(data) {
      this.param.params.zyzt = data
      this.showProcPicker = false
    },
    onDeal() {
      this.showPicker = false
      this.param.params.currentDate = this.getDate(this.currentDate)
    },
    getDate(date) {
      return formatDate(date, 'yyyy-MM-dd')
    },
    onClickRoute(index) {
      // 路由跳转
      let routes = new Map([
        ['/workplace', '/mobile'],
        ['/myWork', '/mobileMydb'],
        ['/createFlow', '/mobileFlow']
      ])
      if (index.startsWith('/flow')) {
        let url = index.replace('/flow', '/mobileForm')
        this.$router.push({ path: url })
      } else {
        this.$router.push({ path: routes.get(index) })
      }
    },
    onClickLeft() {
      this.$router.push({
        path: '/mobile'
      })
    },
    onClickFlow(item) {
      this.$router.push({
        path: '/ddFlow?f=mb&funCode=10001722' + '&id=' + item.businessKey
      })
    }
  }
}
</script>

<style scoped>
.flow-state {
  background: #ebf8f7;
  color: #0db3a6;
  width: 70px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 100px;
  border: 1px solid #0db3a6;
  font-size: 12px;
  float: right;
}
span.formName {
  font-weight: bold;
  font-size: 14px;
}
.span {
  font-size: 15px;
  color: black;
  margin-left: auto;
}
.topBar {
  width: 100%;
  position: fixed;
  z-index: 10;
}
.isMobile {
  top: 0;
}
.notMobile {
  top: 46px;
}
::v-deep .van-step__title {
  transition: color 0.3s;
  display: flex;
}
::v-deep .van-step--vertical:not(:last-child)::after {
  border-bottom-width: 0px;
}
::v-deep .van-steps {
  overflow: inherit;
  background-color: #fff;
}
.card-back {
  height: 20px;
  background-color: #f6f6f6;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
::v-deep .van-nav-bar__text {
  color: #000000;
}
::v-deep .van-nav-bar .van-icon {
  color: #000000;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: 0 12px 12px -12px rgb(100 101 102 / 12%);
}
</style>
